import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import { onAuthStateChanged } from "firebase/auth";
import LandingPage from "./screens/LandingPage/LandingPage";
import TeacherDashboard from "./screens/TeacherDashboard/TeacherDashboard";
import { roles } from "./constants/roles";
import TaskScreen from "./screens/TasksScreen/TaskScreen";
import PiecesScreen from "./screens/PiecesScreen/PiecesScreen";
import RandomMessageScreen from "./screens/RandomMessageScreen/RandomMessageScreen";
import Layout from "./Layout/Layout";
import EmailSignInPage from "./screens/EmailSignInPage/EmailSignInPage";
import PrivacyPolicy from "./screens/PrivacyPolicy/PrivacyPolicy";
import { redirectTo } from "./utils/routes";
import EmailSignUpPage from "./screens/EmailSignUpPage/EmailSignUpPage";
import ResetPassword from "./screens/ResetPassword/ResetPassword";
import { auth } from "./firebase";
import { onSignIn, onSignOut } from "./redux/actions";

const LandingRoutes = ({ initialLoad }) => (
  <Switch>
    <Route exact path="/">
      <LandingPage initialLoad={initialLoad} />
    </Route>
    <Route path="/signin">
      <EmailSignInPage />
    </Route>
    <Route path="/signup">
      <EmailSignUpPage />
    </Route>
    <Route path="/reset-password">
      <ResetPassword />
    </Route>
    <Route path="/privacy-policy">
      <PrivacyPolicy />
    </Route>
  </Switch>
);
function App() {
  const authenticated = useSelector((state) => state.authReducer.authenticated);
  const role = useSelector((state) => state.authReducer.role);
  const history = useHistory();
  const location = useLocation();

  const [initialLoad, setInitialLoad] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        dispatch(onSignOut());
      } else if (user && !user.emailVerified) {
        auth.signOut();
      } else if (user && user.emailVerified) {
        const token = await user.getIdToken();
        dispatch(onSignIn(user.email, token));
      }
      setInitialLoad(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    switch (role) {
      case roles.ADMIN:
        history.replace("/randomMessage");
        break;
      case roles.TEACHER:
        history.replace("/teacher");
        break;
      default:
        redirectTo(location.pathname, history);
        break;
    }
  }, [role]);

  let routes = (
    <Switch>
      <Route path="/teacher/:studentId">
        <TeacherDashboard />
      </Route>
      <Route path="/teacher">
        <TeacherDashboard />
      </Route>
      <Route path="/tasks">
        <TaskScreen />
      </Route>
      <Route path="/pieces">
        <PiecesScreen />
      </Route>
    </Switch>
  );

  if (role === roles.ADMIN) {
    routes = (
      <Switch>
        <Route path="/randomMessage">
          <RandomMessageScreen />
        </Route>
      </Switch>
    );
  }

  return (
    <div className="App">
      {authenticated ? (
        <Layout>{routes}</Layout>
      ) : (
        <LandingRoutes initialLoad={initialLoad} />
      )}
    </div>
  );
}

export default App;
